import clsx from 'clsx';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';

import HeartFilledIcon from 'assets/png/heart-filled.png?format=webp;avif&as=picture';

import styles from './additional-settings-modal-content.module.css';
import { GameLength, HEARTS_BY_GAME_LENGTH } from './constants';

export const getHeartCountByGameLength = (length: GameLength): number =>
  HEARTS_BY_GAME_LENGTH[length];

export const SelectableButton = ({
  label,
  isSelected,
  onClick,
}: {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}) => (
  <button
    onClick={onClick}
    className={clsx(
      'flex h-8 w-full items-center justify-center rounded-lg border px-3 text-[12px] font-medium leading-normal transition lg:h-12 lg:rounded-xl lg:border-[1.5px] lg:text-[18px]',
      isSelected
        ? clsx('text-white', styles['btn-gradient-border'])
        : 'border-transparent text-light-grape',
    )}
  >
    {label}
  </button>
);

export const renderHearts = (length: GameLength) => {
  const totalHearts = getHeartCountByGameLength(length);

  if (length === GameLength.Short) {
    return (
      <div className="flex items-center gap-2">
        {Array.from({ length: totalHearts }).map((_, i) => (
          <OptimizedImage
            key={i}
            imageData={HeartFilledIcon}
            alt="heart-filled"
            className="h-[16px] w-[16px] lg:h-[24px] lg:w-[24px]"
            style={{ objectFit: 'cover' }}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <OptimizedImage
        imageData={HeartFilledIcon}
        alt="heart-filled"
        className="h-[16px] w-[16px] lg:h-[24px] lg:w-[24px]"
      />

      <div
        className="relative flex min-w-[16px] items-center justify-center text-[20px] font-semibold leading-none text-white lg:min-w-6 lg:text-[28px]"
        data-testid="hearts-count"
      >
        <OptimizedImage
          imageData={HeartFilledIcon}
          alt="heart-filled"
          className="absolute left-1/2 top-1/2 h-[16px] w-[16px] -translate-x-1/2 -translate-y-1/2 opacity-20 lg:h-[24px] lg:w-[24px]"
        />
        {totalHearts}
      </div>

      <OptimizedImage
        imageData={HeartFilledIcon}
        alt="heart-filled"
        className="h-[16px] w-[16px] lg:h-[24px] lg:w-[24px]"
      />
    </div>
  );
};
